import BaseController from "confinus_ui/base_controller";

export default class SelectToggleController extends BaseController {
  public static targets = ["privateSelect", "sharedSelect"];

  declare private readonly privateSelectTarget: HTMLSelectElement;
  declare private readonly sharedSelectTarget: HTMLSelectElement;

  public clearSharedSelect() {
    this.sharedSelectTarget.selectedIndex = 0;
  }

  public clearPrivateSelect() {
    this.privateSelectTarget.selectedIndex = 0;
  }
}
